import {createSlice, PayloadAction} from '@reduxjs/toolkit';

import {Background} from '~shared/models';

import {getBackgrounds} from './thunks';

export interface PageBackgroundsState {
    entities: Record<number, Background>;
    status: PageBackgroundsStateStatus;
}

type PageBackgroundsStateStatus = 'init' | 'loading' | 'loaded' | 'error';

const initialState: PageBackgroundsState = {
    entities: {},
    status: 'init',
};

export const {actions, reducer} = createSlice({
    name: 'backgrounds',
    initialState,
    reducers: {
        setBackground(state, {payload: background}: PayloadAction<Background | undefined>) {
            if (!background) return;
            const {id} = background;
            state.entities[id] = background;
        },
    },
    extraReducers: (builder) =>
        builder
            .addCase(getBackgrounds.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(getBackgrounds.fulfilled, (state, action) => {
                const {results} = action.payload;

                state.status = 'loaded';

                results.forEach((item) => {
                    const {id} = item;
                    state.entities[id] = item;
                });
            })
            .addCase(getBackgrounds.rejected, (state) => {
                state.status = 'error';
            }),
});
